module.exports = __webpack_public_path__ + "public/img/1-title.6cba0fbf.png";